import React from 'react'
import COLORS from '../../styles/colors'
import { SVGProps } from '../../types/svg'

const defaultSize = {
  width: 38,
  height: 38,
}

function Pay({ style, color = COLORS.brand.primaryDark }: SVGProps) {
  return (
    <svg style={{ ...defaultSize, ...style }} viewBox='0 0 38 38'>
      <defs>
        <style>{`.prefix__a{fill:${color}}`}</style>
      </defs>
      <path
        className='prefix__a'
        d='M31.951 26.959l-2.137-2.175a.63.63 0 00-.819-.069l-9.31 6.858-3.3-1.551 2.893-.321a.63.63 0 00.555-.63v-2.723a.63.63 0 00-.63-.63h-3.149l-5.307-.542a.63.63 0 00-.315.05l-3.618 1.551H0v1.261h6.946a.629.629 0 00.252-.05l3.587-1.569 5.175.53h2.64v1.563l-2.332.29-3.385-.359a.632.632 0 00-.334 1.2l6.99 3.215a.63.63 0 00.63-.063l9.165-6.732 1.266 1.306-10.533 9.2h-2.859L7.154 32.834a.63.63 0 00-.221-.044H0v1.261h6.826l10.047 3.744a.63.63 0 00.221.038h3.2a.63.63 0 00.416-.158l11.207-9.8.031-.029a.63.63 0 00.003-.887zM33.628 15.772l-3.328-3.46a.63.63 0 00-.4-.2l-6.807-.63h-2.6l.126-1.891 2.465-.5 3.442.769a.631.631 0 00.214 0l3.347-.4-.151-1.261-3.24.347-3.467-.769a.516.516 0 00-.258 0l-3.07.63a.63.63 0 00-.511.58l-.2 3.07v.039a.63.63 0 00.631.629h3.215l6.517.592 3.353 3.511a.63.63 0 00.454.2h4.463v-1.261zM32.53 2.645a.561.561 0 00-.24-.113L21.575.013a.63.63 0 00-.517.12l-6.933 5.042.744 1.021 6.7-4.872 10.3 2.42 5.566 4.33.769-1.015z'
      />
      <path
        className='prefix__a'
        d='M22.296 3.865a.63.63 0 00-.517 0l-3.783 1.891.567 1.122 3.53-1.759 2.887 1.179.466-1.172zM15.776 10.848l-1.109-.166c-.5-.076-.8-.271-.8-.586s.441-.63 1.034-.6h.454c.592 0 1.034.315 1.034.6v.17h1.261v-.17a2.092 2.092 0 00-2.294-1.891h-.454a2.092 2.092 0 00-2.296 1.893 2.017 2.017 0 001.891 1.8l1.09.164c.5.076.8.3.8.586s-.441.6-1.034.6h-.454c-.592 0-1.034-.315-1.034-.6v-.17h-1.259v.17a2.107 2.107 0 002.294 1.859h.454a2.122 2.122 0 002.313-1.825 2.017 2.017 0 00-1.891-1.834z'
      />
      <path
        className='prefix__a'
        d='M20.124 12.021a5.043 5.043 0 11-.416-2.773l1.141-.529a6.287 6.287 0 10.536 3.473z'
      />
      <path className='prefix__a' d='M14.497 7.577h1.261v1.261h-1.261z' />
    </svg>
  )
}

export default Pay
